import {
  GoogleAnalyticsService,
  hasStockFromAvailableBusinesses,
  isLogged,
  isPwaLaunched,
} from '@grupoboticario/barril-del-chavo'
import { BrandName } from 'src/@enums'
import { IResellerModifiedUnion } from 'src/@interfaces'
import { getConfig } from '../getConfig'
import { User } from '../session/SessionControl'

const { businessUnit, genericUser, brandEnv } = getConfig()

const currentUserType = (): string => (isLogged() ? genericUser.catalogSlug : 'cliente')

const resellerIdDimension = (resellerId: string) => {
  if (brandEnv === BrandName.EUDORA) {
    return { dimension18: resellerId }
  } else {
    return { dimension20: resellerId }
  }
}

const cycleDimension = (reseller: IResellerModifiedUnion) => {
  if (reseller.availableBusinessUnits) {
    return { dimension3: reseller.availableBusinessUnits[businessUnit]?.cycle?.id }
  }
}

export const analyticsAppName = businessUnit

export const tagIsConsumer = (reseller: IResellerModifiedUnion) => {
  GoogleAnalyticsService.event({
    dimension2: reseller.catalogSlug,
    dimension4: businessUnit,
    dimension7: User.getInstance().getUserId(),
    dimension9: currentUserType(),
    dimension13: reseller.addressHomeState,
    dimension14: hasStockFromAvailableBusinesses(reseller.availableBusinessUnits, businessUnit)
      ? 'pronta-entrega-ativado'
      : 'pronta-entrega-desativado',
    dimension15: isPwaLaunched(),
    dimension17: reseller.commercialStructureId,
    ...resellerIdDimension(reseller.id),
    ...cycleDimension(reseller),
  })
}

export const tagEvent = (dataLayer: object) => {
  GoogleAnalyticsService.event({
    event: 'event',
    eventCategory: `minhaloja:${analyticsAppName}:catalogo`,
    ...dataLayer,
  })
}

export const tagGA4Event = (dataLayer: object) => {
  GoogleAnalyticsService.event({
    event: 'analytics-event',
    ...dataLayer,
  })
}
